// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"188":"84bdacbd","231":"e85cd6f1","668":"4e56c3ee","721":"a0e8db69","879":"e265787b","998":"a6d42270"}[chunkId] + ".chunk.css";
};